// Task app ortak tema + yardımcılar (CRM temasıyla aynı koyu palet)
export const T = {
  bg: '#0b1220', panel: '#0f172a', card: '#111c2e',
  border: '#1e293b', border2: '#334155',
  text: '#f1f5f9', text2: '#cbd5e1', muted: '#94a3b8', dim: '#64748b',
  blue: '#3b82f6', blueDark: '#1d4ed8', amber: '#f59e0b', green: '#22c55e', red: '#ef4444',
};

export const STATUS = {
  todo:        { label: 'To Do',           color: '#94a3b8' },
  in_progress: { label: 'Devam Ediyor',    color: '#3b82f6' },
  done:        { label: 'Tamamlandı',      color: '#22c55e' },
  blocked:     { label: 'Bloklu',          color: '#ef4444' },
  on_client:   { label: 'Client Bekliyor', color: '#f59e0b' },
  on_hold:     { label: 'Beklemede',       color: '#a855f7' },
};
export const STATUS_ORDER = ['todo','in_progress','blocked','on_client','on_hold','done'];

export function initials(name) {
  if (!name) return '?';
  const p = name.trim().split(/\s+/);
  return ((p[0]?.[0] || '') + (p[1]?.[0] || p[0]?.[1] || '')).toUpperCase();
}

// İsimden stabil renk (avatar)
const AV_COLORS = ['#3b82f6','#22c55e','#f59e0b','#a855f7','#ef4444','#14b8a6','#e11d48','#8b5cf6'];
export function avatarColor(name) {
  let h = 0; for (const c of (name || '')) h = (h * 31 + c.charCodeAt(0)) % 997;
  return AV_COLORS[h % AV_COLORS.length];
}

export function fmtDate(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' });
}
export function toInputDate(v) {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}
